<template>
  <div class="form-group form-check former-input" :class="[ {'former-has-value': model[field.key], 'has-error': hasError}, field.className]">
    <label v-if="to.label">{{ to.label }}</label>
    <div v-for="(option, i) in options" :key="i" class="form-check">
      <input
        :id="'rb_'+field.key+'_'+_uid+'_'+i"
        v-model="model[field.key]"
        type="radio"
        class="form-check-input"
        :value="option.value"
        :name="field.key+'_'+_uid"
        @blur="onBlur"
        @focus="onFocus"
        @click="onClick"
        @change="onChange"
        @keyup="onKeyup"
        @keydown="onKeydown"
      >
      <label class="form-check-label" :for="'rb_'+field.key+'_'+_uid+'_'+i">{{ option.label }}</label>
    </div>
    <small v-if="to.help"><br>{{ to.help }}</small>
    <error-display :form="form" :field="field.key"></error-display>
  </div>
</template>

<script>
import baseField from './baseField'
export default {
  name: 'formerRadio',
  mixins: [baseField],
  computed: {
    options () {
      if (!('options' in this.field)) return []
      return this.field.options.map(option => {
        const hasValue = Object.prototype.hasOwnProperty.call(option, 'value')
        return {
          value: hasValue ? option.value : option,
          label: option.label || option
        }
      })
    }
  },
  mounted () {
    this.model[this.field.key] = this.model[this.field.key] || this.field.default || ''
  },
  methods: {
    onChange: function (e) {
      this.$set(this.form[this.field.key], '$dirty', true)
      this.runFunction('onChange', e)
    }
  }
}
</script>
